/* eslint-disable import/prefer-default-export,react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { walletCurrenciesTypes } from '../../../../../screens/Accounts/constants';

export const WalletsFilter = ({ onChangeType, onChangeSearch, selectedTab }) => {
  const { t: translate } = useTranslation();
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [searchInput, onChangeSearchInput] = useState('');
  const clearSearchInput = () => {
    if (searchInput.trim() === '') {
      setShowSearchInput(false);
    } else {
      onChangeSearchInput('');
      onChangeSearch('');
    }
  };

  const searchInputEl = useRef(null);
  const searchInputElem = useRef(null);

  const handleClickOutside = (e) => {
    if (searchInputEl.current && !searchInputEl.current.contains(e.target)) {
      setShowSearchInput(false);
      document.removeEventListener('mousedown', handleClickOutside);
    }
  };

  useEffect(() => () => document.removeEventListener('mousedown', handleClickOutside), []);

  useEffect(() => {
    if (searchInputElem?.current) {
      searchInputElem.current.focus();
    }
  }, [showSearchInput]);

  const handleOpenSearchInput = () => {
    setShowSearchInput(true);
    document.addEventListener('mousedown', handleClickOutside);
  };

  const handleChangeSearchInput = (value) => {
    onChangeSearchInput(value);
    onChangeSearch(value);
  };

  return (
    <>
      {/* mobile layout */}
      <div className="d-block d-md-none">
        <div className="mt-3 w-100 rounded-4 flex-row-center bg-light border border-shadow">
          <button
            type="button"
            className={`toggle-item ${
              selectedTab === walletCurrenciesTypes.CRYPTO && 'active'
            } btn w-50 p-2 rounded-4`}
            onClick={() => onChangeType(walletCurrenciesTypes.CRYPTO)}>
            {translate('crypto_label')}
          </button>
          <button
            type="button"
            className={`toggle-item ${
              selectedTab === walletCurrenciesTypes.FIAT && 'active'
            } btn w-50 p-2 rounded-4`}
            onClick={() => onChangeType(walletCurrenciesTypes.FIAT)}>
            {translate('stable_tab_label')}
          </button>
        </div>
        <div className="form-group my-3">
          <input
            value={searchInput}
            style={{ borderColor: 'transparent', backgroundColor: 'transparent' }}
            onChange={(e) => handleChangeSearchInput(e.target.value)}
            onKeyDown={(e) => handleChangeSearchInput(e.target.value)}
            onBlur={(e) => handleChangeSearchInput(e.target.value)}
            name="search"
            className="form-control-search bg-light"
            placeholder={translate('select_account_input_placeholder')}
            tabIndex={0}
          />
          {searchInput.length > 0 && (
            <span
              className="icon icon-close-other text-shadow"
              onClick={clearSearchInput}
              onKeyDown={clearSearchInput}
              role="button"
              aria-label="Clear search"
              tabIndex={0}
            />
          )}
          <span className="icon-search icon-search-other text-shadow" />
        </div>
      </div>
      {/* browser layout */}
      <div className="d-none d-md-flex justify-content-between align-items-center">
        <div className="col-5 rounded-4 flex-row-center bg-light border border-disabled ">
          <button
            type="button"
            style={{ height: '2.5rem' }}
            className={`toggle-item ${
              selectedTab === walletCurrenciesTypes.CRYPTO && 'active'
            } btn w-50 p-2 rounded-4`}
            onClick={() => onChangeType(walletCurrenciesTypes.CRYPTO)}>
            {translate('crypto_label')}
          </button>
          <button
            type="button"
            style={{ height: '2.5rem' }}
            className={`toggle-item ${
              selectedTab === walletCurrenciesTypes.FIAT && 'active'
            } btn w-50 p-2 rounded-4`}
            onClick={() => onChangeType(walletCurrenciesTypes.FIAT)}>
            {translate('stable_tab_label')}
          </button>
        </div>
        <div className="col-xl-4 col-3 d-flex flex-row align-items-center justify-content-end">
          {!showSearchInput && (
            <i
              className="icon icon-search-other text-white text-f4 d-block hover-icon"
              role="button"
              onKeyDown={handleOpenSearchInput}
              onClick={handleOpenSearchInput}
              aria-label="Search"
              tabIndex={-1}
            />
          )}

          <div
            className="rounded bg-light p-0 popup-search-input flex-row flex-row-reverse position-relative mt-auto mb-auto"
            style={{ display: showSearchInput ? 'flex' : 'none' }}
            ref={searchInputEl}>
            <input
              ref={searchInputElem}
              value={searchInput}
              onChange={(e) => handleChangeSearchInput(e.target.value)}
              onKeyDown={(e) => handleChangeSearchInput(e.target.value)}
              onBlur={(e) => handleChangeSearchInput(e.target.value)}
              name="search"
              className="form-control border-1 border-transparent bg-light shadow-none w-100 ps-5 d-flex"
              placeholder={translate('select_account_input_placeholder')}
              tabIndex={0}
            />
            {searchInput.length > 0 && (
              <span
                className="position-absolute end-0 top-0 px-3 py-3 icon icon-close-other h-100 d-flex align-items-center justify-content-center text-shadow"
                onClick={clearSearchInput}
                onKeyDown={clearSearchInput}
                role="button"
                aria-label="Clear search"
                tabIndex={0}
              />
            )}
            <span className="position-absolute start-0 top-0 px-3 py-3 icon icon-search-other h-100 d-flex align-items-center justify-content-center text-shadow" />
          </div>
        </div>
      </div>
    </>
  );
};

WalletsFilter.propTypes = {
  onChangeType: PropTypes.func.isRequired,
  onChangeSearch: PropTypes.func.isRequired,
  selectedTab: PropTypes.string.isRequired,
};
